import { CdkDropList } from '@angular/cdk/drag-drop';
import { Component, ViewChild, ViewEncapsulation, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../animations/page-transitions';
import { User } from '../../../models/user';
import { UserService } from '../../../services/user.service';

import { WidgetContentChecker } from './available-widgets';

@Component({
	selector: 'copo-issue-follow-up-selector',
	templateUrl: './issue-follow-up-content-selector.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule]
})
export class IssueFollowUpContentSelectorComponent implements OnInit, WidgetContentChecker {
	@ViewChild('selectedContainerList') selectedContainerList?: CdkDropList;
	@ViewChild('availableContainterList') availableContainterList?: CdkDropList;
	@Input() currentContent?: unknown;
	@Output() readonly content = new EventEmitter<unknown>(true);

	user: User;
	type = 'followup';

	constructor(private readonly userService: UserService) {
		this.user = this.userService.user;
	}

	ngOnInit() {
		this.content.emit({ type: this.type });
	}

	getContent() {
		return { type: this.type };
	}

	typeChanged(type: string) {
		this.type = type;
	}
}
